import React from "react";
import ListItemText from "@mui/material/ListItemText";
import { EditTextFieldDialog } from "./EditTextFieldDialog";
import Typography from "@mui/material/Typography";

/**
 * @param {object} props
 * @param {string} props.primary
 * @param {string} props.secondary
 * @param {React.ReactNode} props.helperText
 * @param {(text: (string)) => Promise<void>} props.onSave
 * @param {boolean} props.isBusy
 * @param {(v: (string)) => string} [props.formatter]
 */
export const EditableListItemText = ({ primary, secondary, onSave, isBusy, helperText, formatter = (x) => x }) => {
  return (
    <EditTextFieldDialog
      onSave={onSave}
      title={primary}
      initialValue={secondary}
      isBusy={isBusy}
      helperText={helperText}
      multiline={false}
    >
      <ListItemText primary={primary} secondary={formatter(secondary) || "Click to edit."} />
    </EditTextFieldDialog>
  );
};

/**
 * @param {object} props
 * @param {string} props.primary
 * @param {number} props.secondary
 * @param {string} props.helperText
 * @param {(text: (number)) => Promise<void>} props.onSave
 * @param {boolean} props.isBusy
 * @param {(v: (number)) => string} [props.formatter]
 */
export const EditableListItemNumber = ({
  primary,
  secondary,
  onSave,
  isBusy,
  helperText,
  formatter = (x) => (x === undefined ? `` : `${x}`),
}) => {
  return (
    <EditTextFieldDialog
      onSave={onSave}
      title={primary}
      initialValue={secondary}
      isBusy={isBusy}
      helperText={helperText}
    >
      <ListItemText primary={primary} secondary={formatter(secondary) || "Click to edit."} />
    </EditTextFieldDialog>
  );
};

/**
 * @param {object} props
 * @param {string} props.primary
 * @param {number|undefined} props.secondary
 * @param {string} props.helperText
 * @param {(text: (number|undefined)) => Promise<void>} props.onSave
 * @param {boolean} props.isBusy
 * @param {(v: (number|undefined)) => string} [props.formatter]
 */
export const EditableListItemNumberWithUndefined = ({
  primary,
  secondary,
  onSave,
  isBusy,
  helperText,
  formatter = (x) => (x === undefined ? `` : `${x}`),
}) => {
  return (
    <EditTextFieldDialog
      onSave={onSave}
      title={primary}
      initialValue={secondary}
      isBusy={isBusy}
      helperText={helperText}
    >
      <ListItemText primary={primary} secondary={formatter(secondary) || "Click to edit."} />
    </EditTextFieldDialog>
  );
};

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.initialValue
 * @param {string} props.helperText
 * @param {(text: (string)) => Promise<void>} props.onSave
 * @param {boolean} props.isBusy
 * @param {(v: (string)) => string} [props.formatter]
 */
export const EditableText = ({ title, initialValue, onSave, isBusy, helperText }) => {
  return (
    <EditTextFieldDialog
      onSave={onSave}
      title={title}
      initialValue={initialValue}
      isBusy={isBusy}
      helperText={helperText}
    >
      <Typography variant="inherit">{initialValue}</Typography>
    </EditTextFieldDialog>
  );
};
